(() => {
  const getSectionId = (gallery) => gallery.id.replace('MediaGallery-', '');

  const filterGallery = (gallery, featuredMediaId) => {
    if (!gallery || gallery.dataset.variantMediaFilter !== 'true') return;

    const group = featuredMediaId ? String(featuredMediaId) : '';
    const groupedItems = Array.from(gallery.querySelectorAll('[data-variant-media-group]'));
    const hasSelectedGroup = group && groupedItems.some((item) => item.dataset.variantMediaGroup === group);

    groupedItems.forEach((item) => {
      const itemGroup = item.dataset.variantMediaGroup;
      item.hidden = Boolean(hasSelectedGroup && itemGroup !== group && itemGroup !== 'shared');
    });

    const visibleSlides = Array.from(
      gallery.querySelectorAll('[id^="Slider-Gallery-"] > li[data-media-id]:not([hidden])')
    );
    const counter = gallery.querySelector('.slider-counter--total');
    if (counter) counter.textContent = visibleSlides.length;

    const activeMedia = visibleSlides.find((item) => item.classList.contains('is-active')) || visibleSlides[0];
    if (activeMedia) {
      gallery.setActiveMedia?.(activeMedia.dataset.mediaId, false);
    }

    gallery.querySelector('[id^="GalleryViewer-"]')?.resetPages?.();
    gallery.querySelector('[id^="GalleryThumbnails-"]')?.resetPages?.();
  };

  const initialize = (root = document) => {
    root.querySelectorAll?.('media-gallery[data-variant-media-filter="true"]').forEach((gallery) => {
      filterGallery(gallery, gallery.dataset.selectedVariantMedia);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const gallery = document.getElementById(`MediaGallery-${data.sectionId}`);
      filterGallery(gallery, data.variant?.featured_media?.id);
    });
  }

  window.PrithviyaVariantMedia = { filterGallery };
})();
